import React from 'react';
import { Row, Col } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import SecLogo from '../../../../utility/unnamed.png';
import SecBuilding from '../../../../assets/files/img/aaa.jpg';

const PrivacyNotice = () => {
  return (
    <div className="relative min-h-screen overflow-x-hidden">
      {/* ── Background Image ── */}
      <img
        src={SecBuilding}
        alt=""
        aria-hidden="true"
        fetchPriority="high"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />

      {/* ── Dark Gradient Overlay ── */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(100deg, rgba(0,36,22,0.93) 0%, rgba(0,50,32,0.82) 45%, rgba(0,30,18,0.65) 100%)',
        }}
      />

      {/* ── Main Canvas Layer ── */}
      <div
        style={{
          position: 'relative',
          zIndex: 10,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
        }}
      >
        {/* Centered Content Wrapper */}
        <div className="flex-1 flex flex-col items-center justify-center p-4 sm:p-8 md:p-12">
          
          {/* Centered Scrollable Document Card */}
          <div
            className="w-full max-w-4xl bg-white rounded-[20px] p-6 sm:p-10 my-auto"
            style={{ boxShadow: '0 24px 80px rgba(0,0,0,0.35)' }}
          >
            {/* Header / Branding Inside Card */}
            <header className="flex flex-col items-center text-center mb-6 pb-6 border-b border-gray-100">
              <img
                src={SecLogo}
                alt="SEC Logo"
                style={{ height: 60, width: 'auto', marginBottom: 12 }}
              />
              <h1 className="text-xl md:text-2xl font-extrabold text-[#111827] mb-1">
                Electronic Filing and Submission Tool (eFAST)
              </h1>
              <p className="text-xs sm:text-sm text-gray-500 mb-2">
                Facility Privacy Notice &amp; User Consent
              </p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: '0.08em',
                    padding: '2px 10px',
                    borderRadius: 999,
                    background: 'rgba(15,130,105,0.1)',
                    color: '#0f8269',
                    border: '1px solid rgba(15,130,105,0.2)',
                  }}
                >
                  PRIVACY NOTICE
                </span>
              </div>
            </header>

            {/* Document Content Body */}
            <div
              className="text-gray-700 text-sm leading-relaxed max-h-[60vh] overflow-y-auto pr-2"
              style={{ textAlign: 'justify' }}
            >
              <p className="font-bold text-center text-base text-gray-900 mb-4">
                PRIVACY NOTICE
              </p>
              
              <p className="mb-4">
                The <strong>SECURITIES AND EXCHANGE COMMISSION (SEC)</strong> is committed to protect and respect your personal data privacy. We are at the forefront of not only implementing but also complying with the Data Privacy Act of 2012 (RA No. 10173), and pertinent issuances of the National Privacy Commission (NPC).
              </p>

              {/* Section 1 */}
              <h3 className="font-bold text-base mb-1" style={{ color: '#0f8269' }}>
                1. What services does the SEC eFAST Platform provide?
              </h3>
              <p className="mb-2 pl-3">
                The SEC Electronic Filing and Submission Tool (eFAST) platform is an online facility to be used for submitting the Audited Financial Statement (AFS), General Information Sheet (GIS), Sworn Statement for Foundations (SSF), General Form for Financial Statements (GFFS), Special Form for Financial Statement (SFFS) and other reportorial requirements. All corporations registered with SEC must enroll in the eFAST in order to access and submit reports through the system.
              </p>
              <p className="mb-4 pl-3">
                Facility Link: <a href="https://efast.sec.gov.ph/" target="_blank" rel="noopener noreferrer" className="text-[#0f8269] underline font-medium">https://efast.sec.gov.ph/</a>
              </p>

              {/* Section 2 */}
              <h3 className="font-bold text-base mb-1" style={{ color: '#0f8269' }}>
                2. What personal information do we collect?
              </h3>
              <div className="mb-4 pl-3">
                <p className="mb-2">We collect the following personal information:</p>
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={12}>
                    <ul className="list-disc pl-5 m-0 space-y-1">
                      <li>Full name</li>
                      <li>Tax Identification Number (TIN)</li>
                      <li>Mobile Phone Number</li>
                    </ul>
                  </Col>
                  <Col xs={24} sm={12}>
                    <ul className="list-disc pl-5 m-0 space-y-1">
                      <li>Email Address</li>
                      <li>Address</li>
                      <li>Other information indicated in compliance documents</li>
                    </ul>
                  </Col>
                </Row>
              </div>

              {/* Section 3 */}
              <h3 className="font-bold text-base mb-1" style={{ color: '#0f8269' }}>
                3. Why do we need to collect personal information?
              </h3>
              <p className="mb-4 pl-3">
                The collected Personal Data will be utilized in the processing of the eFAST applications for registration.
              </p>

              {/* Section 4 */}
              <h3 className="font-bold text-base mb-1" style={{ color: '#0f8269' }}>
                4. When do we collect personal information?
              </h3>
              <p className="mb-4 pl-3">
                Personal information is collected during the registration process for the eFAST platform when an applicant or their representative submits personal data to register and use the platform's services. This data is required for processing their application for registration to subscribe to the online services.
              </p>

              {/* Section 5 */}
              <h3 className="font-bold text-base mb-1" style={{ color: '#0f8269' }}>
                5. Why do we collect personal information, and is all information necessary?
              </h3>
              <p className="mb-4 pl-3">
                The personal information is collected to process the application for registration on the eFAST platform. The information, such as full name, TIN, mobile number, email, and address, is necessary to complete the registration process and ensure that the correct person or representative is applying to use the system for submitting reports. While the personal data is necessary for system registration, it also aids in communication and ensuring compliance with SEC requirements.
              </p>

              {/* Section 6 */}
              <h3 className="font-bold text-base mb-1" style={{ color: '#0f8269' }}>
                6. How do we collect personal information?
              </h3>
              <p className="mb-4 pl-3">
                We collect, use and process the Personal Data provided through electronic or automated means to proceed in this registration system as subscriber of the eFAST.
              </p>

              {/* Section 7 */}
              <h3 className="font-bold text-base mb-1" style={{ color: '#0f8269' }}>
                7. How do we store the data collected?
              </h3>
              <p className="mb-2 pl-3">
                The SEC ensures the protection of personal data against accidental or unlawful destruction, alteration, disclosure, and other unlawful processing by implementing appropriate security measures based on the nature of the data.
              </p>
              <p className="mb-2 pl-3">
                Personal information of SEC personnel is retained and disposed of in accordance with civil service laws and the National Archives of the Philippines Act of 2007.
              </p>
              <p className="mb-2 pl-3">
                Personal data from contractors and service providers are retained for one year after contract expiration. After this period, hard copies are securely destroyed, and soft copies are deleted.
              </p>
              <p className="mb-4 pl-3">
                Similarly, personal data from job applicants are retained for one year from collection. After this period, hard copies are securely disposed of, and soft copies are deleted.
              </p>

              {/* Section 8 */}
              <h3 className="font-bold text-base mb-1" style={{ color: '#0f8269' }}>
                8. How do we dispose of the data collected?
              </h3>
              <p className="mb-4 pl-3">
                Once a record has passed its retention period and is no longer needed, all hard and soft copies of personal information will be securely disposed of and destroyed. Authorized disposal methods include shredding, burial, or sale to a buyer. This process will be carried out in the presence of a Records Management Analyst from the National Archives of the Philippines (NAP), a SEC COA representative, and members of the SEC RMIC, such as the Chairperson, Vice-Chairperson, and relevant Departmental Directors/Records Focals (or their alternates).
              </p>

              {/* Section 9 */}
              <h3 className="font-bold text-base mb-1" style={{ color: '#0f8269' }}>
                9. What are the risks involved in processing your personal information?
              </h3>
              <p className="mb-2 pl-3">
                Risk refers to the potential for incidents that may harm a data subject or organization, including unauthorized collection, use, disclosure, or access to personal data. It involves threats to the confidentiality, integrity, and availability of personal data or violations of data privacy principles and rights.
              </p>
              <p className="mb-2 pl-3">
                The SEC implements physical, technical, and organizational security measures to protect personal data but acknowledges that risks like cyberattacks, malware, and unauthorized access to manual records may still occur.
              </p>
              <p className="mb-4 pl-3">
                Adequate policies are in place to manage security incidents, in alignment with NPC policies, circulars, and other relevant issuances.
              </p>

              {/* Section 10 */}
              <h3 className="font-bold text-base mb-1" style={{ color: '#0f8269' }}>
                10. How do we keep your personal information secure?
              </h3>
              <p className="mb-4 pl-3">
                Only authorized SEC personnel are granted access to the Personal Data collected through the registration system. The collected Personal Data via the internet or other electronic methods are stored in a secured database. We use reasonable security safeguards to protect the information gathered from any loss, unauthorized access, use or disclosure.
              </p>

              {/* Section 11 */}
              <h3 className="font-bold text-base mb-1" style={{ color: '#0f8269' }}>
                11. What are the rights of the data subjects?
              </h3>
              <p className="mb-4 pl-3">
                Under the Data Privacy Act of 2012, data subject refers to an individual whose Personal Data is collected and processed. We are duly bound to observe and respect your privacy rights, including your right to information, right to access, right to correct, right to remove, right to damages and right to data portability.
              </p>

              {/* Section 12 */}
              <h3 className="font-bold text-base mb-1" style={{ color: '#0f8269' }}>
                12. How can data subjects exercise these rights?
              </h3>
              <p className="mb-6 pl-3">
                Data subjects may file a request with the Data Protection Officer (DPO). They may contact the DPO at 8818-7204, send an email to <a href="mailto:dpo@sec.gov.ph" className="text-[#0f8269] underline">dpo@sec.gov.ph</a> or file a complaint through <a href="https://imessage.sec.gov.ph" target="_blank" rel="noopener noreferrer" className="text-[#0f8269] underline">imessage.sec.gov.ph</a>.
              </p>

              <hr className="my-6 border-gray-200" />

              {/* Consent Form Section */}
              <p className="font-bold text-center text-base text-gray-900 mb-2">
                CONSENT FORM OF SYSTEM USER
              </p>
              <p className="mb-6">
                By using this facility and by providing your Personal Data, you hereby authorize the Securities and Exchange Commission (SEC) to collect and store the said data. Data such as but not limited to your full name, nationality, TIN, email address and mobile number with the use of electronic or automated means, shall be stored within the period allowed under applicable laws, rules and regulations, for the purpose of processing your application for registration to subscribe on the online services of the eFAST. You also acknowledge and consent to the collection and processing of your personal data as part of the requirements for registration.
              </p>

              <hr className="my-6 border-gray-200" />

              {/* Feedback Section */}
              <p className="font-bold text-center text-base text-gray-900 mb-2">
                FEEDBACK ON THE PRIVACY NOTICE
              </p>
              <p className="mb-3">
                If you have any questions, concerns, or requests related to this Privacy Notice, or if you would like to exercise your rights under applicable data protection laws, please contact our Data Protection Officer, Director Oliver V. Chato:
              </p>
              <ul className="list-disc pl-8 mb-4 space-y-1">
                <li>Email: <a href="mailto:dpo@sec.gov.ph" className="text-[#0f8269] underline">dpo@sec.gov.ph</a></li>
                <li>Phone: 8818-7204</li>
              </ul>
            </div>

            {/* Card Footer Actions */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justify: 'space-between',
                width: '100%',
                marginTop: 20,
                paddingTop: 20,
                borderTop: '1px solid #f3f4f6',
              }}
            >
              <Link
                to="/user/login"
                style={{
                  color: '#0f8269',
                  fontWeight: 600,
                  fontSize: 14,
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                }}
              >
                <ArrowLeftOutlined /> Back to Sign In
              </Link>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PrivacyNotice;